import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from './index';

export function usePageTracking() {
  const location = useLocation();
  const lastPath = useRef(location.pathname);

  useEffect(() => {
    if (location.pathname !== lastPath.current) {
      analytics.pageView(location.pathname);
      lastPath.current = location.pathname;
    }
  }, [location]);
}

export function useTrackMount(category: string, action: string, label?: string) {
  useEffect(() => {
    analytics.track({ category, action, label });
  }, [category, action, label]);
}

export function useTrackEvent(category: string, action: string, label?: string) {
  return () => analytics.track({ category, action, label });
}

export function useTrackFunnel(name: string) {
  const startFunnel = (step: string) => {
    analytics.startFunnel(name, step);
  };

  const completeFunnelStep = (step: string, nextStep: string) => {
    analytics.completeFunnelStep(name, step, nextStep);
  };

  const abandonFunnel = (step: string, reason?: string) => {
    analytics.abandonFunnel(name, step, reason);
  };

  return { startFunnel, completeFunnelStep, abandonFunnel };
}